import script from "./Signature.vue?vue&type=script&setup=true&lang=js"
export * from "./Signature.vue?vue&type=script&setup=true&lang=js"

import "./Signature.vue?vue&type=style&index=0&id=64847ece&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/barmm-admin-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64847ece"]])

export default __exports__